module.exports = __webpack_public_path__ + "img/sliders_2-06.cbb1e5fe.png";